// Paths of the ledger screens and the links they hand to other modules.
// Document links exist only where another module has published a contract:
//   invoice         → /accounts/invoices/:id                                (documents invoiceViewHref)
//   receipt voucher → /accounts/vouchers?panel=receipt-voucher&voucher_id=  (vouchers receiptVoucherViewHref)
//   payment voucher → /accounts/vouchers?panel=payment-voucher&voucher_id=  (payables contract)
//   purchase        → /inventory/purchases/:id                              (when erp.inventory is on)
// Transfers and stock moves have no published read-only view yet (no panel
// takes their id), so those numbers render without a link.

import { invoiceViewHref } from '../../documents/lib/links';
import { paymentVoucherViewHref, receiptVoucherViewHref } from '../../vouchers/lib/links';

export const JOURNAL_PATH = '/accounts/journal';
export const LEDGER_PATH = '/accounts/ledger';
/** Query flag that opens the manual-entry panel over the journal (deep-linkable). */
export const MANUAL_PANEL = 'manual';

function qs(params: Record<string, string | undefined | null>): string {
  const s = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) if (v) s.set(k, v);
  const out = s.toString();
  return out ? `?${out}` : '';
}

export function ledgerHref(accountId: string, opts: { period?: string; entry?: string } = {}): string {
  return `${LEDGER_PATH}/${encodeURIComponent(accountId)}${qs({ period: opts.period, entry: opts.entry })}`;
}

export function journalHref(opts: { period?: string; entry?: string; panel?: string } = {}): string {
  return `${JOURNAL_PATH}${qs({ period: opts.period, entry: opts.entry, panel: opts.panel })}`;
}

export function manualEntryHref(period?: string): string {
  return journalHref({ period, panel: MANUAL_PANEL });
}

/** Where a journal row's document opens, or null when no module publishes that link yet. */
export function documentHref(sourceType: string, sourceId: string | null, flags: { inventory: boolean }): string | null {
  if (!sourceId) return null;
  switch (sourceType) {
    case 'invoice':
      return invoiceViewHref(sourceId);
    case 'receipt_voucher':
      return receiptVoucherViewHref(sourceId);
    case 'payment_voucher':
      return paymentVoucherViewHref(sourceId);
    case 'purchase':
      return flags.inventory ? `/inventory/purchases/${encodeURIComponent(sourceId)}` : null;
    default:
      return null;
  }
}

/** The period-close page for a month (owner's reopen lives there — HANDOFF §5.8). */
export function closeHref(period: string): string {
  return `/accounts/close${qs({ period })}`;
}
